import Icon from '../components/Icon.vue'

Icon.register({"camera":{"width":512,"height":512,"paths":[{"d":"M512 144V432C512 458.5 490.5 480 464 480H48C21.5 480 0 458.5 0 432V144C0 117.5 21.5 96 48 96H136L148.3 63.1C155.3 44.4 173.2 32 193.2 32H318.7C338.7 32 356.6 44.4 363.6 63.1L376 96H464C490.5 96 512 117.5 512 144zM376 288C376 221.8 322.2 168 256 168S136 221.8 136 288 189.8 408 256 408 376 354.2 376 288zM344 288C344 336.5 304.5 376 256 376S168 336.5 168 288 207.5 200 256 200 344 239.5 344 288z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/camera.js
// module id = null
// module chunks = 